import React, { useEffect, useState } from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import MySearch from "../Common/MySearch";
import { Button, Form, Nav, Tab } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import EventDateIcon from "../../assets/icons/Icon_Library/application icons/assets/events/event_start_end_cal-.svg2";
import EditIcon from "../../assets/icons/Icon_Library/application icons/assets/events/edit-01.svg2";
import { loadTagOptions } from "../helpers/loadTagOptions";

export default function MySolutionFilter({ filters, setFilters }) {
  const [search, setSearch] = useState("");
  useEffect(() => {
    const first = setTimeout(() => {
      setFilters({ ...filters, search, offset: 0 });
    }, 500);

    return () => {
      clearTimeout(first);
    };
  }, [search]);
  return (
    <div>
      <div className=" bg-colored-reverse p-3 m-0 rounded-3 mb-3">
        <div className="row justify-content-between align-items-center">
          {/* <div className="col-2">
          <span className="fw-bold p-2 text-white mb-2">Components:</span>

          <Form.Select
            aria-label="components-select"
            onChange={(e) => {
              setOrderBy(e.target.value);
            }}
            value={orderBy}
          >
            <option value="workflow-project">Workflow project</option>
            <option value="api">API</option>
            <option value="monitor">Monitor</option>
          </Form.Select>
        </div> */}
          <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">Status:</span>

            <Form.Select
              aria-label="status-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  status: e.target.value ? [e.target.value] : [],
                  offset: 0,
                });
              }}
              value={filters.status?.[0] || ""}
            >
              <option value="public">published</option>
              <option value="draft">draft</option>
              <option value="">all</option>
            </Form.Select>
          </div>
          <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">Kind:</span>

            <Form.Select
              aria-label="kind-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  kind: e.target.value ? [e.target.value] : [],
                  offset: 0,
                });
              }}
              value={filters.kind?.[0] || ""}
            >
              <option value="category">Category</option>
              <option value="solution-type">Solution Type</option>
              <option value="business-use-case">Business use-case</option>
              <option value="">all</option>
            </Form.Select>
          </div>
          <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">Deployed:</span>

            <Form.Select
              aria-label="deployed-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  deployed: e.target.value,
                  offset: 0,
                });
              }}
              value={filters.deployed || ""}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
              <option value="">all</option>
            </Form.Select>
          </div>
          {/* <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">Purchased:</span>

            <Form.Select
              aria-label="purchased-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  purchased: e.target.value,
                  offset: 0,
                });
              }}
              value={filters.purchased}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
              <option value="">all</option>
            </Form.Select>
          </div> */}
        </div>
        <div className="row justify-content-start align-items-center">
          <div className="col-4 mt-3">
            <span className="fw-bold p-2 text-white mb-2">Industry types:</span>

            <Input
              placeholder="Industry types"
              inputType="select"
              isMulti
              isValidNewOption={(o) => o}
              value={filters.industry || []}
              isClearable
              onChange={(v) => {
                setFilters({ ...filters, industry: v, offset: 0 });
              }}
              loadOptions={loadTagOptions("industry")}
            />
          </div>

          <div className="col-4 mt-3 ">
            <div className="fw-bold  text-white">Search:</div>
            <div className="">
              <MySearch
                placeholder="Search by name, reference, description..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
          </div>
          {/* <div className="col-4 mt-3 d-flex gap-2">
          <div className="mt-3">
            <Button className="px-2 p-2 border-0 bg-white fw-bold text-nowrap w-100 d-flex justify-content-between align-items-center">
              <div className="text-navy w-25 text-start">STARTS:</div>
              <div className="flex-grow-1">
                <ReactDatePicker
                  // selected={
                  //   event?.StartedAt ? new Date(event.StartedAt) : null
                  // }
                  // onChange={(date) => {
                  //   setEvent({ ...event, StartedAt: date.toISOString() });
                  // }}
                  showTimeSelect
                  dateFormat="Pp"
                  className="form-control"
                />
              </div>
              <div>
                <EditIcon width={20} className=" ms-3" />
              </div>
            </Button>
          </div>
          <div className="mt-3">
            <Button className="px-2 p-2 border-0 bg-white fw-bold text-nowrap w-100 d-flex justify-content-between align-items-center">
              <div className="text-navy w-25 text-start">ENDS:</div>
              <div className="flex-grow-1">
                <ReactDatePicker
                  // selected={event?.EndedAt ? new Date(event.EndedAt) : null}
                  // onChange={(date) => {
                  //   setEvent({ ...event, EndedAt: date.toISOString() });
                  // }}
                  showTimeSelect
                  dateFormat="Pp"
                  className="form-control"
                />
              </div>
              <div>
                <EditIcon width={20} className=" ms-3" />
              </div>
            </Button>
          </div></div> */}
        </div>
      </div>
    </div>
  );
}
